import React from "react";

import { Close } from "@mui/icons-material";
import { IconButton, IconButtonProps, Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface Props {
  children?: React.ReactNode;
  onIconClick?: () => void | Promise<void>;
  icon?: JSX.Element;
  containerProps?: StackProps;
  titleProps?: TypographyProps;
  iconButtonProps?: Omit<IconButtonProps, "onClick">;
}

const defaultContainerSx: StackProps["sx"] = {
  p: " 0 10px 0 20px",
  bgcolor: "#edf1f9",
  height: "50px",
  minWidth: "120px",
  flexShrink: 0
};
const defaultTitleSx: TypographyProps["sx"] = {
  color: "#0a3142",
  fontSize: "16px"
};
// const defaultBtnSx: IconButtonProps["sx"] = {}; // If some default styling should be;

export const SimpleHeadMui: React.FC<Props> = ({
  children,
  icon,
  onIconClick,
  containerProps,
  titleProps,
  iconButtonProps
}) => {
  const { sx: containerSx, ...restContainerProps } = containerProps || {};
  const { sx: titlePropsSx, ...restTitlePropsProps } = titleProps || {};

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ ...defaultContainerSx, ...containerSx }}
      {...restContainerProps}
    >
      <MaterialTooltip title={children || ""} isShow>
        <Typography noWrap sx={{ ...defaultTitleSx, ...titlePropsSx }} {...restTitlePropsProps}>
          {children || ""}
        </Typography>
      </MaterialTooltip>
      <IconButton onClick={onIconClick} {...iconButtonProps}>
        {icon ? icon : <Close sx={{ fontSize: "20px", color: "#0a3142" }} />}
      </IconButton>
    </Stack>
  );
};
